import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private _collection$: Subject<any[]> = new Subject();

  constructor(private http: HttpClient) {}

  public load(teamName: string): Observable<any[]> {
    this.http.get(`${ConfigService.apiUrl}/users/${teamName}`).subscribe((response: any) => {
      this._collection$.next(response);
    });

    return this._collection$.asObservable();
  }
}
